var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatePersonalDetailsConfirmationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 399,
    viewBox: "0 0 500 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.007 199.107C230.243 199.107 275.011 154.541 275.011 99.5534C275.011 44.5657 230.243 0 175.007 0C119.77 0 75.0029 44.5657 75.0029 99.5534C75.0029 154.541 119.77 199.107 175.007 199.107ZM245.01 223.995H231.962C214.618 231.928 195.32 236.439 175.007 236.439C154.694 236.439 135.474 231.928 118.051 223.995H105.004C47.0331 223.995 0 270.816 0 328.526V360.881C0 381.492 16.7975 398.213 37.5015 398.213H252.275C250.4 392.925 249.619 387.325 250.244 381.647L255.557 334.282L256.494 325.648L262.667 319.504L323.06 259.383C303.918 237.839 276.183 223.995 245.01 223.995ZM280.402 337.004L275.089 384.447C274.229 392.38 280.949 399.069 288.839 398.136L336.419 392.847L444.158 285.594L388.14 229.828L280.402 337.004ZM494.551 209.14L464.94 179.663C457.674 172.43 445.799 172.43 438.533 179.663L409 209.062L405.797 212.251L461.893 268.016L494.551 235.506C501.817 228.195 501.817 216.451 494.551 209.14Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatePersonalDetailsConfirmationIcon);
export default __webpack_public_path__ + "static/media/update-personal-details-confirmation-icon.700523d09c62999ad8e1efa47a466510.svg";
export { ForwardRef as ReactComponent };